<template>
  <div class="boxtop">
    <i></i>
    <span>{{ calsstop.title }}</span>
    <template>
      <div class="any">
        <slot></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ["calsstop"],
  data() {
    return {};
  }
};
</script>

<style scoped lang="less">
.boxtop {
  display: flex;
  justify-content: flex-start;
	background-color: #FFFFFF;
  height: 50px;
  width: 100%;
  margin: auto;
  align-items: center;
  padding: 10px;
  box-sizing: border-box;
  & > i {
		width: 4px;
		height: 18px;
		background-color: rgba(70, 122, 255, 1);
		margin-right: 10px;
		border-radius: 4px;
  }
  & > span {
    flex: 1;
    text-align: left;
		font-size: 18px;
		font-weight: bold;
		line-height: 20px;
  }
  .any{
    cursor: pointer;
  }
}
</style>
